<div class="loading-history loading-history--visible">
  <div class="loading-history__panel">
    <div class="loading-history__spinner" aria-hidden="true"></div>
    <div class="loading-history__text">Cargando historial…</div>
  </div>
</div>
